import { Component, Vue } from "vue-property-decorator";

import * as Constant from "@/constant";
import { Example } from "@/components";
import { LangManager } from "@/lang";
import { Log } from "@/util";

@Component<AdminHomeIndexController>({
  components: {
    Example
  }
})
export default class AdminHomeIndexController extends Vue {
  private textHash!: { [page: string]: { [key: string]: string } };

  // lifecycle example
  public beforeCreate() {
    Log.info("beforeCreate");
  }

  public created() {
    Log.info("created");
    this.$data.textHash = LangManager.getTextHashByPage("home");
  }

  public beforeMount() {
    Log.info("beforeMount");
  }

  public mounted() {
    Log.info("mounted");
  }

  // method example
  private methodExample() {
    Log.info(this.$data.textHash); // How to get data in vue (varable declare above)
    Log.info(Constant.ErrorCode.ServerError); // How to use constant
  }
}
